<template> 
  <div class="panel box viz">
    <div class="panel-header panel-controls">
      <h3>{{ component.name }}  <button class="btn btn-icon pull-right" @click="showControls = !showControls"><i v-if="isEditable" class="fa fa-ellipsis-v"></i></button></h3>
       <div v-if="is_admin && isEditable" class="control-btn">
        <transition name="fade">
          <div v-show="showControls" class="control-btn-submenu">
            <ul>
              <li v-if="!component.corrupt"><a role="button" @click="fetchRenderData"><i class="fa fa-refresh"></i> Reload</a></li>
              <li v-if="!component.corrupt"><a role="button" @click="editComponent"><i class="fa fa-cog"></i>  Edit</a></li>
              <li v-if="!component.corrupt"><a role="button" @click="cloneComponent"><i class="fa fa-clone"></i>  Clone</a></li>
              <li><a role="button" @click="removeComponent"><i class="fa fa-trash"></i> Remove</a></li>
            </ul>
          </div>
        </transition>
      </div>
    </div>
    <div class="panel-content chart-wrapper" :class="{ 'plotly-chart': renderData.type == 'chart' }">
        <div v-if="component.corrupt" class="corrupt-component">
            <div><i class="fa fa-ban fa-3x fa-fw"></i></div>
            
            <div>This widget could not be rendered, please remove it.</div>
            
        </div>
        <viz-widget v-else
            :isLoading="loading"
            :chartId="component.id"
            :renderData="renderData"
            :height="height"
            :width="width">
        </viz-widget>
    </div>
  </div> 
</template>

<script>
import Vue from 'vue';

 import VizWidget from 'components/elements/VizWidget';

// Load the full build. 
var _ = require('lodash');

export default {
     components: {
         VizWidget
     },
     props: {
         isEditable: {
             type: Boolean,
             default: true
         },
         dashboardRules: Object,
         height: {
             type: Number
         },
         width: {
             type: Number
         },
         datesRange: {
             type: Object,
             default () {
                 return {
                     from: null,
                     to: null,
                     date_field: null
                 }
             }
         },
         index: null,
         component: {
             type: Object,
             default () {
                 return {
                     id: null,
                     name: null,
                     chart: null,
                     corrupt: false,
                     series_list: [
                         {
                             name: null,
                             scale: null,
                             xaxis_obj: { kind: null, field: null, fieldChoices: [] }, 
                             yaxis_list: [ { name: null, aggregation: undefined, scoring_mode: null, rule: null } ] 
                         }
                     ],
                     rendered_widget: null
                 };
             }
         },
     },
     data () {
         return {
             is_admin: false,
             loading: false,
             hasEvent: false,
             renderData: {
                 type: null,
                 layout: null,
                 series: []
             },
             showControls: false,
         };
     },
     computed: {
         dashboardId () {
             return this.$route.params.id;
         },
         chartChoices () {
             return API.components.getChartChoices();
         },
         hasDefaultTable () {
             var user = this.$store.state.user;
             var account = user.current_account;
             return account.default_table && account.default_table != 'null';
         },
         componentFilters () {
             if (this.dashboardRules) {
                 if (!this.component.filter_rule) {
                     return this.dashboardRules;
                 }
                 return {
                     expression_type: 'and',
                     negate: false,
                     operands: [this.dashboardRules,
                                this.component.filter_rule]
                 }
             }
             else if (this.component.filter_rule) {
                 return this.component.filter_rule;
             }
             return null;
         }
     },
     created () {
         var self = this;
         var u = this.$store.state.user;
         this.is_admin = u.role == "admin" || u.role == "superuser";
         self.$parent.$on('resized', function () {
             self.$emit('resized');
         });
         if (this.component.rendered_widget) {
             this.renderData = this.component.rendered_widget;
             this.loading = false;
         }
         else if (!this.component.corrupt) {
             this.fetchRenderData();
         }
     },
     watch: {
         dashboardRules: {
             handler: function () {
                 if (this.isEditable) {
                     this.fetchRenderData();
                 }
             },
             deep: true
         },
         datesRange: {
             handler: function () {
                 if (this.isEditable) {
	             this.fetchRenderData();
                 }
             },
             deep: true
         },
         component: {
             handler: function(newComponent) {
                 if (newComponent.rendered_widget) {
                     this.renderData = newComponent.rendered_widget;
                 }
             },
             deep: true
         }
     },
     methods: {
         buildRequestData () {
             var requestData = {
                 id: this.component.id,
                 name: this.component.name,
                 chart: this.component.chart,
                 domains: this.component.domains,
                 filter_rule: this.componentFilters,
                 images: []
             };
             var rules = [];

             for (var i in this.component.images) {
                 var currentImage = {
                     id: this.component.images[i].id,
                     name: this.component.images[i].name,
                     kind: this.component.images[i].kind,
                     series: []
                 };

                 for (var s in this.component.images[i].series) {
                     var currentSerie = {
                         id: this.component.images[i].series[s].id,
                         name: this.component.images[i].series[s].name,
                         aggregation: this.component.images[i].series[s].aggregation,
                         filter_rule: this.component.images[i].series[s].filter_rule
                     };

                     if (this.component.images[i].kind == 'count') {
                         currentSerie.aggregation = 'count';
                     }
                     if (this.component.images[i].kind == 'score' && this.component.images[i].series[s].scoring_model) {
                         currentSerie.scoring_model = this.component.images[i].series[s].scoring_model;
                     }
                     if (this.component.images[i].kind == 'value' && this.component.images[i].series[s].field) {
                         currentSerie.field = this.component.images[i].series[s].field;
                     }
                     // Checking the rules of the current image's serie   
                     if (this.component.images[i].series[s].rules && this.component.images[i].series[s].rules.clause) {
                         currentSerie.rules = this.component.images[i].series[s].rules;
                     }
                     else {
                         currentSerie.rules = null;
                     }

                     currentImage.series.push(currentSerie);
                 }
                 requestData.images.push(currentImage);
             }

             return requestData;
         },
         fetchRenderData () {
             if (this.loading) {
                 return
             };
             var self = this;
             self.loading = true;
             var requestData = self.buildRequestData();

             self.renderData = {};
             API.components.renderPreview(self.dashboardId, requestData, self.datesRange)
                .then( // OnSuccess
                       function (response) {
                           self.renderData = response.data;
                           self.loading = false;
                       }, // OnFail
                       function (err) {
                           self.loading = false;
                       }
                );
             self.showControls = false;
         },
         editComponent() {
             if (this.isEditable) {
                 this.$emit('showEditModal', this.index);
                 this.showControls = false;
             }

         },
         cloneComponent () {
             if (this.isEditable) {
                 this.$emit('cloneComponent', this.component);
                 this.showControls = false;
             }

         },
         removeComponent () {
             if (this.isEditable) {

                 this.showControls = false;
                 var msg = "This action will be permanently and it can't be recovered. Are you sure you want to continue?";
                 if (confirm(msg) === true) {
                     this.$emit( 'deleteComponent', this.component.i);
                 }
             }
         },
     }
};
</script>


<style lang="scss" scoped>
  @import "./static/css/_variables.scss";
  
.viz.box {
  height: 100%;
  width: 100%;
  padding: 0px;
}

.viz .chart-wrapper {
    padding: 0px;
    overflow: hidden;
    
    &.plotly-chart {
     padding-bottom: 1em;
    }
 }
 
.viz .chart-wrapper>div {
  height: 100%;
}
.viz .chart-holder {
  height: 100%;
  font-size: 9em;
  color: #ccc;
}
.viz .chart-holder i {
  padding: 20px;
}

.viz .chart-wrapper .vertical-center {
  padding-top: 12%;
  padding-bottom: 12%;
}

.viz.panel .panel-content.chart-wrapper .fa {
  padding: 0;
}

.viz {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .corrupt-component {
        flex: 1;
        background: #e3e3e3;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .panel-content {
        flex: 1;
      
    .metrics-banner-text {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 1.8em;
      font-weight: 600;
      margin-left: auto;
      margin-right: auto;
      color: $ls-highlight-color;
      
      h5 {
        color: $ls-base-color;
        font-weight: 500;
        font-size: .6em;
      }

      .metric-value {
        padding-bottom: 15px;
      }
    } 
  }
  
  .panel-header {
    background-color:#fffcfc;
  }
  
  .panel-controls {    
    .control-btn-submenu {
      box-shadow: $ls-menu-shadow;
      position: relative;
      z-index: 99999;
      width: 140px;
      margin-top: 0em;
      margin-left: -140px;
      background-color: #fff;
      padding: 10px;
      border-radius: 0px 0px 4px 4px;
      
      ul {
        margin: 0;
        padding: 0;
        
        li {
          line-height: 2.2;
          list-style: none;

          a {
            vertical-align: middle;
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ComponentBox.vue?4f1e42c4